// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__PHIrw","resumeUpload":"Hero_resumeUpload__E8HeB"};